import { TEST_ID } from './constants';
import type { CSSProperties, FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ToggleSlider: FunctionComponent<Props> = ({
    activeIndex,
    className = '',
    optionCount,
    testId = TEST_ID
}) => (
    <div
        style={
            {
                '--toggle-slider-active-index': activeIndex,
                '--toggle-slider-option-count': optionCount
            } as CSSProperties
        }
        className={`${className} ${styles.toggleSlider}`}
        data-testid={testId}
    />
);

export default ToggleSlider;
